import { SynchTripResultImportDTO } from 'business/models/Models';
import React from 'react';
import { ImportTripResultColumns } from '../constants';
import RMTable, {
  RowExtraInfo,
  RowInfoType,
} from 'components/customComponents/Controls/RMTable';
interface TableProps {
  tableData: SynchTripResultImportDTO[];
}

const SynchTripResultTable = (props: TableProps) => {
  const { tableData } = props;

  const getRowExtraInfo = () => {
    const tableRowInfo: RowExtraInfo = {};
    tableData.map((row, index) => {
      if (row.isDataInvalid) {
        tableRowInfo[index] = { msg: row.validationMessage, type: RowInfoType.Error };
      }
    });
    return tableRowInfo;
  };

  return (
    <RMTable
      columns={ImportTripResultColumns}
      data={tableData}
      mainContainerStyle={{ height: '100%' }}
      headerClassName="whitespace-nowrap w-32"
      cellClassName="w-32"
      rowExtraInfo={getRowExtraInfo()}
    />
  );
};

export default SynchTripResultTable;
